import { createRouter, createWebHistory } from 'vue-router'
import { setupRouterGuards } from '@/router/guards'
import '@/router/types' // Import route meta types
// Import route modules
import authRoutes from '@/apps/auth/router'
import homeRoutes from '@/apps/home/router'
import { assetsRoutes } from '@/apps/assets/router'
import { channelsRoutes } from '@/apps/channels/router'
import showcasesRoutes from '@/apps/showcases/router'
import analyticsRoutes from '@/apps/analytics/router'
import subtitlesRoutes from '@/apps/subtitles/router'
import settingsRoutes from '@/apps/settings/router'
import helpdeskRoutes from '@/apps/helpdesk/router'
import streamsRoutes from '@/apps/streams/router'
import incidentsRoutes from '@/apps/incidents/router'
import actionsRoutes from '@/apps/actions/router'
import dashboardRoutes from '@/apps/dashboard/router'
import productionLinesRoutes from '@/apps/production-lines/router'
import playgroundRoutes from '@/dev/playground/router'
import vodMockupsRoutes from '@/vod-mockups/router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0, behavior: 'smooth' }
    }
  },
  routes: [

    // VOD Mockups (public, no auth required)
    ...vodMockupsRoutes,

    // ============= Error/404 Route =============
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('@/core/components/SystemError.vue'),
      meta: {
        requiresAuth: false,
        title: 'Page Not Found',
      },
    },
  ],
})

// Apply all navigation guards

export default router
